export default {
  formBuilder: {
    templateLoadingText: 'Veuillez patienter... Création du modèle en cours',
    exitPromptErrorMessage: 'Toutes les modifications non enregistrées seront perdues. Voulez-vous vraiment quitter?',
    unsavedChangesModal: {
      title: 'Modifications non enregistrées',
      body: 'Si vous quittez, vos modifications seront perdues. Cette action est irréversible.',
      exit: 'Quitter',
      continueEditing: 'Continuer à modifier',
    },
    elementList: {
      searchPlaceholder: 'Rechercher des composants',
      title: 'Faire glisser ou cliquer pour ajouter',
      langSelector: {
        title: 'Langues actives',
        languages: {
          en: 'Anglais',
          fr: 'Français',
        },
      },
      clearButton: 'Effacer',
      clearMessage: 'Voulez-vous vraiment effacer le modèle ?',
      saveButton: {
        save: 'Enregistrer',
        update: 'Mettre à jour',
        saveAsCopy: 'Enregistrer une copie',
      },
      createdSuccessfully: 'Modèle créé avec succès',
      updatedSuccessfully: 'Modèle mis à jour avec succès',
      saveError: 'Une erreur est survenue lors du traitement de votre modèle.',
      confirmSaveModal: {
        title: 'Enregistrer les modifications',
        body: `Ce modèle est utilisé pour {{count}} poste(s). L'enregistrement mettra à jour immédiatement les postes et l'affichage candidat. Continuer ?`,
        cancel: 'Annuler',
        proceed: 'Continuer et enregistrer',
      },
    },
    header: {
      templateNameInputPlaceholder: 'Nom du modèle de question',
    },
    schema: {
      freeform: {
        label: 'Champ libre',
        chipLabel: 'Champ libre',
      },
      yesno: {
        label: 'Oui/Non',
        chipLabel: 'Oui/Non',
        branches: ['Oui', 'Non'],
      },
      multiChoice: {
        label: 'Choix multiple',
        chipLabel: 'Choix multiple',
      },
      yesnoWithImage: {
        label: 'Oui/Non avec image',
        chipLabel: 'Oui/Non',
        branches: ['Oui', 'Non'],
      },
      multiChoiceWithImage: {
        label: 'Choix multiple avec image',
        chipLabel: 'Choix multiple',
      },
      videoResponse: {
        label: 'Réponse vidéo asynchrone',
        chipLabel: 'Réponse vidéo asynchrone',
      },
      documentUpload: {
        label: 'Chargement de document',
        chipLabel: 'Chargement de document',
      },
    },
    preview: {
      title: 'Aperçu',
      deviceViewButton: 'Vue appareil',
      listViewButton: 'Vue liste',
      listView: {
        noQuestions: 'Aucune question pour le moment.',
        noQuestionText: 'Question sans titre',
        optionTextPlaceholder: 'Option {{index}}',
        conditionIf: '↳ Si « {{condition}} »',
      },
      mobileView: {
        title: 'Profil de poste',
        headerTitle: 'Gestionnaire des pièces',
        information: 'INFORMATION',
        messaging: 'MESSAGERIE',
        welcome: {
          title: 'Candidature en cours',
          question: `Merci d'avoir commencé ta candidature ! Répondre aux questions suivantes pour terminer.`,
        },
        question: {
          defaultTitle: 'Question du recruteur',
          noQuestionText: 'Sélectionne la meilleure option',
          writeQuestionText: 'Écris ta réponse ici',
        },
        mcqSelectSingle: 'Sélectionne plusieurs option',
        mcqSelectMultiple: 'Sélectionne plusieurs options',
        optionNoText: 'Option {{index}}',
        documentUpload: {
          info:
            'Appuie sur le bouton ci-dessous pour charger ton document. Le fichier doit être au format JPG, PNG, JPEG, DOC ou PDF, peser moins de 5 Mo et être bien lisible. Un seul fichier peut être chargé.',
          info_plural:
            'Clique sur le bouton ci-dessous pour charger ton document. Le fichier doit être au format JPG, PNG, JPEG, DOC ou PDF, peser moins de 5 Mo et être bien lisible. {{count}} fichiers maximum peuvent être chargés.',
          skipQuestionInfo: "Je n'ai pas ce qui est demandé",
          upload: 'Télécharger',
          capture: 'Capturer',
        },
        videoResponse: {
          skipQuestionInfo: 'Je ne peux pas fournir ce qui est demandé',
          header: 'Enregistrement vidéo requis',
          instruction:
            'Enregistre une courte vidéo dans un endroit calme et bien éclairé. Un bruit de fond ou un mauvais éclairage pourraient compromettre ton évaluation. La vidéo ne doit pas dépasser {{count}} minute(s).',
          questionTitle: 'Répondre à cette question face à la caméra',
          footerNote: "Cette question reste visible pendant l'enregistrement",
          start: 'Démarrer',
        },
      },
    },
    canvas: {
      emptyContent: 'Cliquez sur les éléments à gauche pour construire votre formulaire.',
      dropMessage: 'INSÉRER ICI',
      maxDepthError: 'DÉPÔT IMPOSSIBLE : Nombre maximum de questions de suivi atteint.',
      noDropError: 'DÉPÔT IMPOSSIBLE : Vous ne pouvez pas placer cet élément ici.',
      element: {
        questionInputPlaceholder: 'Tapez votre question ici ({{limit}} caractères max)',
        deleteQuestionMessage: 'Voulez-vous vraiment supprimer cette question ?',
        addFollowUp: 'Ajouter une question de suivi',
        followNextQuestion: 'Afficher les questions suivantes sur',
        requireResponse: {
          label: 'Réponse obligatoire pour toutes les candidatures',
          info: 'Poser à nouveau cette question si le candidat postule de nouveau.',
        },
        screeningTypes: {
          label: 'Type de filtrage',
          none: 'Aucun',
          knockout: 'Éliminatoire - Rejet automatique si mauvaise réponse',
          review: 'Révision - Évaluation manuelle',
        },
        maxCharactersInputLabel: 'Limite maximale de la réponse',
        maxCharactersInputPlaceholder: 'ex. 50',
        validationRules: {
          title: 'Règles de validation',
          ruleText1: 'Quand le candidat sélectionne',
          ruleText2: 'option, la réponse',
          ruleText2_plural: 'options, les réponses',
          any: `n'importe laquelle`,
          of: 'parmi',
          selectOptionNoSelection: 'Sélectionner les options',
          selectOptionWithSelection: 'Options : {{selectedOptions}}',
          operator: {
            IS_EQUAL: {
              label: 'doit être égale à',
              description: 'Les options sélectionnées doivent correspondre exactement',
            },
            HAS_ANSWER: {
              label: 'doit inclure',
              description: 'Les options sélectionnées doivent inclure les éléments spécifiés',
            },
            DOES_NOT_HAVE_ANSWER: {
              label: 'ne doit pas inclure',
              description: 'Les options sélectionnées ne doivent pas inclure les éléments spécifiés',
            },
            AT_LEAST: {
              label: 'doit inclure au moins',
              description: 'Doit inclure au moins ces options',
            },
          },
          videoResponse: {
            maxVideoLength: 'Durée max. :',
            minLabel: 'min',
          },
        },
        options: {
          title: 'Options de réponse',
          addOption: 'Ajouter une option',
          optionTextPlaceholder: `Entrez le texte de l'option ici`,
        },

        documentUpload: {
          supportedTypeTitle: 'Formats de fichiers autorisés:',
          supportedTypes: 'JPG, PNG, JPEG, DOC, PDF',
          validationRuleText1: 'Le candidat doit charger ',
          validationRuleText2: 'fichier. Taille max : 5 Mo.',
          skipQuestionLabel: 'Les candidats peuvent ignorer cette étape',
        },
      },
    },
    validationErrors: {
      validationRules: {
        noOptionSelected: 'Choisissez au moins une bonne réponse.',
        isEqual: {
          exactCountRequired: 'Choisissez exactement 1 bonne réponse.',
          exactCountRequired_plural: 'Choisissez exactement {{count}} bonnes réponses.',
          exceedsAvailable: 'Vous avez choisi trop d’options. Veuillez en retirer.',
        },
        mustInclude: {
          tooManySelected: 'Vous pouvez choisir jusqu’à 1 option.',
          tooManySelected_plural: 'Vous pouvez choisir jusqu’à {{count}} options.',
          exceedsAvailable: 'Vous avez choisi trop d’options.',
        },
        mustNotInclude: {
          needsMoreOptions: 'Au moins 2 options sont nécessaires.',
          mustLeaveOneOption: 'Au moins une option doit rester non sélectionnée.',
          tooManySelected: 'Vous pouvez exclure jusqu’à 1 option.',
          tooManySelected_plural: 'Vous pouvez exclure jusqu’à {{max}} options.',
        },
        atLeast: {
          minCountRequired: 'Indiquez un minimum d’options.',
          minExceedsSelection: 'Le minimum ({{minCount}}) ne peut pas dépasser les options choisies ({{selectionCount}}).',
          notEnoughOptionsSelected: 'Choisissez au moins 1 bonne réponse.',
          notEnoughOptionsSelected_plural: 'Choisissez au moins {{minCount}} bonnes réponses.',
        },
      },
      optionEmpty: `Le texte de l'option ne peut pas être vide`,
      optionRequired: `Le texte de l'option est requis`,
      optionMax: `Le texte de l'option ne doit pas dépasser {{limit}} caractères`,
      optionMin: `Le texte de l'option ne peut pas être vide`,
      imageMin: 'Veuillez ajouter au moins une image pour ce type de question',
      imageRequired: 'Au moins une image est requise pour ce type de question',
      questionTextEmpty: 'Veuillez saisir la question',
      questionTextRequired: 'Le texte de la question est requis',
      questionTextMax: 'Le texte de la question ne peut excéder {{limit}} caractères',
      questionTextMin: 'Le texte de la question ne peut pas être vide',
      maxLengthBase: 'Veuillez saisir une limite de caractères valide',
      maxLengthInteger: 'La limite de caractères doit être un nombre entier',
      maxLengthMin: `La limite de caractères doit être d'au moins 1`,
      maxLengthMax: 'La limite de caractères ne peut excéder {{limit}}',
      maxLengthRequired: 'Limite de caractères requise pour les champs libres',
      templateNameEmpty: 'Veuillez saisir un nom de modèle',
      templateNameMin: 'Le nom du modèle doit contenir au moins 1 caractère',
      templateNameMax: 'Le nom du modèle ne peut excéder {{limit}} caractères',
      templateNameRequired: 'Le nom du modèle est requis',
      localeOnly: 'Veuillez sélectionner une langue de question valide',
      localeRequired: 'Veuillez sélectionner une langue de question',
      localeEmpty: 'Veuillez sélectionner une langue de question',
      defaultBase: 'Par défaut doit être un booléen',
      defaultRequired: 'Par défaut est requis',
      questionsMin: 'Veuillez ajouter au moins une question',
      questionsRequired: 'Au moins une question est requise',
    },
  },
  modal: {
    screeningType: 'Type de filtrage',
    requireResponseAllApplications: 'Réponse obligatoire pour toutes les candidatures',
    maxAnswerLength: 'Longueur maximale de réponse',
    characters: '{{count}} caractère',
    characters_plural: '{{count}} caractères',
    expectedAnswer: 'Réponse attendue',
    answerOptions: 'Options de réponse',
    candidatesCanSkip: 'Les candidats ont la possibilité d’ignorer cette question',
  },
  validationMessages: {
    isEqual:
      'Les candidats doivent choisir <bold>{{total}}</bold> {{totalOptionLabel}}. Les réponses <bold>doivent être exactement</bold> : <bold>{{letters}}</bold>',

    hasAnswer:
      'Les candidats doivent choisir <bold>{{total}}</bold> {{totalOptionLabel}}. Les réponses <bold>doivent inclure</bold> : <bold>{{letters}}</bold>',

    doesNotHaveAnswer:
      'Les candidats doivent choisir <bold>{{total}}</bold> {{totalOptionLabel}}. Les réponses <bold>ne doivent pas inclure</bold> : <bold>{{letters}}</bold>',

    atLeast:
      'Les candidats doivent choisir <bold>{{total}}</bold> {{totalOptionLabel}}. Les réponses <bold>doivent inclure au moins {{min}}</bold> de : <bold>{{letters}}</bold>',

    option: 'option',
    options: 'options',
  },
};
